/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */

/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */

// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript'
// @ts-ignore
// prettier-ignore
import type { RequestConfig, RequestFunctionRestArgs } from 'yapi-to-typescript'
// @ts-ignore
import request from '../../../request';

type UserRequestRestArgs = RequestFunctionRestArgs<typeof request>;

// Request: 目前 React Hooks 功能有用到
export type Request<
  TRequestData,
  TRequestConfig extends RequestConfig,
  TRequestResult
> = (TRequestConfig['requestDataOptional'] extends true
  ? (requestData?: TRequestData, ...args: RequestFunctionRestArgs<typeof request>) => TRequestResult
  : (requestData: TRequestData, ...args: RequestFunctionRestArgs<typeof request>) => TRequestResult) & {
  requestConfig: TRequestConfig;
};

const mockUrl_0_0_0_1 = 'http://10.50.16.213:40001/mock/295' as any;
const devUrl_0_0_0_1 = '' as any;
const prodUrl_0_0_0_1 = 'http://127.0.0.1' as any;
const dataKey_0_0_0_1 = 'retdata' as any;

/**
 * @分类 [mock表单管理↗](http://10.50.16.213:40001/project/295/interface/api/cat_2063)
 * @请求头 `GET /api/form/{id}`
 */
export interface FormIdGetRequest {
  /**
   * 模板id
   */
  id: string;
}

/**
 * @分类 [mock表单管理↗](http://10.50.16.213:40001/project/295/interface/api/cat_2063)
 * @请求头 `GET /api/form/{id}`
 */
export interface FormIdGetResponse {
  /**
   * 主键
   */
  id?: number;
  /**
   * 名称
   */
  name?: string;
  /**
   * 说明
   */
  description?: string;
  /**
   * 表单模板id
   */
  formTemplateId?: number;
  /**
   * 表单模板名称
   */
  formTemplateName?: string;
  /**
   * 创建人staff id
   */
  createCropUserId?: string;
  /**
   * 创建人名称
   */
  createCropUserName?: string;
  /**
   * 更新人staff id
   */
  updateCropUserId?: string;
  /**
   * 更新人名称
   */
  updateCropUserName?: string;
  /**
   * 创建时间
   */
  createTime?: {
    /**
     * The number of seconds from the epoch of 1970-01-01T00:00:00Z.
     */
    seconds?: number;
    /**
     * The number of nanoseconds, later along the time-line, from the seconds field.
     * This is always positive, and never exceeds 999,999,999.
     */
    nanos?: number;
  };
  /**
   * 更新时间
   */
  updateTime?: {
    /**
     * The number of seconds from the epoch of 1970-01-01T00:00:00Z.
     */
    seconds?: number;
    /**
     * The number of nanoseconds, later along the time-line, from the seconds field.
     * This is always positive, and never exceeds 999,999,999.
     */
    nanos?: number;
  };
  /**
   * 字段列表
   */
  paramValues?: {
    id?: number;
    /**
     * 名称
     */
    param?: string;
    /**
     * 类型
     */
    paramType?: 1 | 2 | 3;
    /**
     * 文本值
     */
    paramText?: string;
    /**
     * 引用的规则id
     */
    paramRuleId?: number;
    /**
     * 引用的规则名称
     */
    paramRuleName?: number;
    /**
     * 函数类型
     */
    paramFunction?: 1 | 2;
  }[];
}

/**
 * @分类 [mock表单管理↗](http://10.50.16.213:40001/project/295/interface/api/cat_2063)
 * @请求头 `GET /api/form/{id}`
 */
type ApiFormIdGetRequestConfig = Readonly<
  RequestConfig<
    'http://10.50.16.213:40001/mock/295',
    '',
    'http://127.0.0.1',
    '/api/form/{id}',
    'retdata',
    'id',
    string,
    false
  >
>;

/**
 * @分类 [mock表单管理↗](http://10.50.16.213:40001/project/295/interface/api/cat_2063)
 * @请求头 `GET /api/form/{id}`
 */
const apiFormIdGetRequestConfig: ApiFormIdGetRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_1,
  devUrl: devUrl_0_0_0_1,
  prodUrl: prodUrl_0_0_0_1,
  path: '/api/form/{id}',
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: ['id'],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'apiFormIdGet',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * @分类 [mock表单管理↗](http://10.50.16.213:40001/project/295/interface/api/cat_2063)
 * @请求头 `GET /api/form/{id}`
 */
export const apiFormIdGet = /*#__PURE__*/ (requestData: FormIdGetRequest, ...args: UserRequestRestArgs) => {
  return request<FormIdGetResponse>(prepare(apiFormIdGetRequestConfig, requestData), ...args);
};

apiFormIdGet.requestConfig = apiFormIdGetRequestConfig;

/**
 * @分类 [mock表单管理↗](http://10.50.16.213:40001/project/295/interface/api/cat_2063)
 * @请求头 `PUT /api/form/{id}`
 */
export interface FormIdPutRequest {
  /**
   * 名称
   */
  name: string;
  /**
   * 说明
   */
  description?: string;
  /**
   * 字段列表
   */
  paramValues?: {
    /**
     * 名称
     */
    param?: string;
    /**
     * 类型
     */
    paramType?: 1 | 2 | 3;
    /**
     * 文本值
     */
    paramText?: string;
    /**
     * 引用的规则id
     */
    paramRuleId?: number;
    /**
     * 函数类型
     */
    paramFunction?: 1 | 2;
  }[];
  /**
   * 模板id
   */
  id: string;
}

/**
 * @分类 [mock表单管理↗](http://10.50.16.213:40001/project/295/interface/api/cat_2063)
 * @请求头 `PUT /api/form/{id}`
 */
export interface FormIdPutResponse {}

/**
 * @分类 [mock表单管理↗](http://10.50.16.213:40001/project/295/interface/api/cat_2063)
 * @请求头 `PUT /api/form/{id}`
 */
type ApiFormIdPutRequestConfig = Readonly<
  RequestConfig<
    'http://10.50.16.213:40001/mock/295',
    '',
    'http://127.0.0.1',
    '/api/form/{id}',
    'retdata',
    'id',
    string,
    false
  >
>;

/**
 * @分类 [mock表单管理↗](http://10.50.16.213:40001/project/295/interface/api/cat_2063)
 * @请求头 `PUT /api/form/{id}`
 */
const apiFormIdPutRequestConfig: ApiFormIdPutRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_1,
  devUrl: devUrl_0_0_0_1,
  prodUrl: prodUrl_0_0_0_1,
  path: '/api/form/{id}',
  method: Method.PUT,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: ['id'],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'apiFormIdPut',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * @分类 [mock表单管理↗](http://10.50.16.213:40001/project/295/interface/api/cat_2063)
 * @请求头 `PUT /api/form/{id}`
 */
export const apiFormIdPut = /*#__PURE__*/ (requestData: FormIdPutRequest, ...args: UserRequestRestArgs) => {
  return request<FormIdPutResponse>(prepare(apiFormIdPutRequestConfig, requestData), ...args);
};

apiFormIdPut.requestConfig = apiFormIdPutRequestConfig;

/**
 * @分类 [mock表单管理↗](http://10.50.16.213:40001/project/295/interface/api/cat_2063)
 * @请求头 `DELETE /api/form/{id}`
 */
export interface FormIdDeleteRequest {
  /**
   * 模板id
   */
  id: string;
}

/**
 * @分类 [mock表单管理↗](http://10.50.16.213:40001/project/295/interface/api/cat_2063)
 * @请求头 `DELETE /api/form/{id}`
 */
export interface FormIdDeleteResponse {}

/**
 * @分类 [mock表单管理↗](http://10.50.16.213:40001/project/295/interface/api/cat_2063)
 * @请求头 `DELETE /api/form/{id}`
 */
type ApiFormIdDeleteRequestConfig = Readonly<
  RequestConfig<
    'http://10.50.16.213:40001/mock/295',
    '',
    'http://127.0.0.1',
    '/api/form/{id}',
    'retdata',
    'id',
    string,
    false
  >
>;

/**
 * @分类 [mock表单管理↗](http://10.50.16.213:40001/project/295/interface/api/cat_2063)
 * @请求头 `DELETE /api/form/{id}`
 */
const apiFormIdDeleteRequestConfig: ApiFormIdDeleteRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_1,
  devUrl: devUrl_0_0_0_1,
  prodUrl: prodUrl_0_0_0_1,
  path: '/api/form/{id}',
  method: Method.DELETE,
  requestHeaders: {},
  requestBodyType: RequestBodyType.none,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: ['id'],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'apiFormIdDelete',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * @分类 [mock表单管理↗](http://10.50.16.213:40001/project/295/interface/api/cat_2063)
 * @请求头 `DELETE /api/form/{id}`
 */
export const apiFormIdDelete = /*#__PURE__*/ (requestData: FormIdDeleteRequest, ...args: UserRequestRestArgs) => {
  return request<FormIdDeleteResponse>(prepare(apiFormIdDeleteRequestConfig, requestData), ...args);
};

apiFormIdDelete.requestConfig = apiFormIdDeleteRequestConfig;

/* prettier-ignore-end */
